import Button from "../../../form/Button";
import FileUpload from "../../../form/FileUpload";
import NotFound from "../../extra/NoDataFound";
import Progress from "../../extra/Progress";
import Storage from "./components/storage/Storage";

const Documents = ({
  data = [],
  progress = 0,
  onChange = () => {},
  setData = () => {},
  loading = false,
  fundraiserId,
}) => {
  return (
    <div
      className={`w-full h-full relative ${
        Array.isArray(data) && data?.length === 0
          ? "flex items-center justify-center"
          : ""
      }`}
    >
      {!loading && Array.isArray(data) && data?.length === 0 && (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <div className="w-full">
            {progress > 0 && Array.isArray(data) && data?.length === 0 && (
              <div className="flex flex-col items-center mb-4">
                <Progress progress={progress} />
                <span className="text-[10px] font-semibold text-green-500 mt-2">
                  Uploading... {progress}%
                </span>
              </div>
            )}
            <div className="text-center">
              You may want to upload bills, diagnosis report , death
              certificate, educational admission report and any other document.
            </div>
            <div className="mt-2 flex justify-center">
              <FileUpload onChange={(val) => onChange(val)} className="w-1/2" />
            </div>
          </div>
        </div>
      )}
      {Array.isArray(data) && (
        <Storage
          data={data}
          progress={progress}
          loading={loading}
          setData={setData}
          fundraiserId={fundraiserId}
        />
      )}
    </div>
  );
};

export default Documents;
